function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.954,
    height: 14.954,
    viewBox: "0 0 14.954 14.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M689.76 368.3a1.04 1.04 0 0 1-.739-.306l-12.863-12.863a1.046 1.046 0 0 1 1.479-1.479l12.863 12.866a1.046 1.046 0 0 1-.739 1.785z",
    transform: "translate(-675.852 -353.349)",
    style: {
      fill: "#cdcdd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.9 368.3a1.046 1.046 0 0 1-.739-1.785l12.863-12.863a1.046 1.046 0 0 1 1.479 1.479L677.637 368a1.04 1.04 0 0 1-.74.306z",
    transform: "translate(-675.852 -353.349)",
    style: {
      fill: "#cdcdd8"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/X_icon.b91df984.svg";
export { ForwardRef as ReactComponent };